// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1i7ml","unreadBadge":"styles_unreadBadge__1jphN","modalContent":"styles_modalContent__1a2Wl","modal":"styles_modal__2Cm0R"};